import { Link } from "react-router-dom"
import DeferredFooterBlaze from "./DeferredFooterBlaze"

const linkClass = "inline-flex min-h-10 w-fit items-center rounded-md text-sm text-white/60 outline-none transition-colors hover:text-white focus-visible:ring-2 focus-visible:ring-[#D19DFF] focus-visible:ring-offset-2 focus-visible:ring-offset-[#121113]"

const Footer = () => {
	return (
		<div className="relative isolate w-full overflow-hidden border-t border-white/10">
			<DeferredFooterBlaze />
			<footer className="w-full px-4">
				<div className="container-wrapper">
					<div className="grid grid-cols-2 gap-x-8 gap-y-6 py-6 lg:grid-cols-[minmax(0,1fr)_12rem_12rem] lg:gap-16 lg:py-8">
						<div className="col-span-2 lg:col-span-1">
							<Link
								to="/"
								aria-label="Errorism Store home"
								className="flex min-h-12 w-fit items-center gap-3 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-[#D19DFF] focus-visible:ring-offset-4 focus-visible:ring-offset-[#121113]"
							>
									<img src="/img/logo/main.svg" className="w-8" alt="" height="236" width="172" />
									<img src="/img/logo/sss.svg" className="w-36" alt="Errorism" height="18" width="154" />
							</Link>

							<div className="mt-3 flex flex-col text-sm text-white/60">
								<a href="mailto:contact@errorism.co" className={linkClass}>contact@errorism.co</a>
								<span className="leading-6">Bangkok, Thailand</span>
							</div>
						</div>

						<nav aria-label="Help" className="flex flex-col">
							<p className="mb-3 text-sm font-medium text-white">Help</p>
							<a href="https://docs.errorism.co/" target="_blank" rel="noreferrer" className={linkClass}>Documentation</a>
							<a href="https://cfx.errorism.co/discord" target="_blank" rel="noreferrer" className={linkClass}>Discord</a>
						</nav>

						<nav aria-label="Legal" className="flex flex-col">
							<p className="mb-3 text-sm font-medium text-white">Legal</p>
							<Link to="/policy" className={linkClass}>Privacy Policy</Link>
							<Link to="/tos" className={linkClass}>Terms of Service</Link>
						</nav>
					</div>

					<div className="border-t border-white/10 py-4">
						<p className="text-xs text-white/45">© 2026 Errorism &amp; Godji. All rights reserved.</p>
					</div>
				</div>
			</footer>
		</div>
	)
}

export default Footer
